import * as $ from 'jquery';
import 'bootstrap-notify';

let growl = {
	warning,
	info,
	success,
	error,
	neutral,
}

function warning(msg: string) {
	notify('warning',msg);
	return msg;
}
function info(msg: string) {
	notify('info',msg);
	return msg;
}
function success(msg: string) {
	notify('success',msg);
	return msg;
}
function error(msg: string) {
	notify('danger',msg, 'alert-error');
	return msg;
}

function neutral(msg: string) {
	notify('info', msg,'neutral','');
	return msg;
}

function notify(type: string, msg: string, customClass = '', icon = 'icon') {
	if (!msg) {
		return;
	}
	let a = $.notify({
		message: msg,
	},{
		z_index: 1050,
		type: type,
		delay: 2000,
		// delay: 0,
		template: `
		<div class="growl-container growl-fixed">
		<div
		class="growl-item alert ng-scope alert-{0} ${customClass} ${icon} alert-dismissable"
		>
		<button
		data-notify="dismiss"
		type="button"
		class="close"
		aria-hidden="true"
		>
		×</button
		>
		<h4 style="display: none"
		class="growl-title"
		>{1}</h4>
		<div
		class="growl-message">
		{2}
		</div>
		</div>
		</div>
		`,
	});
	a.$ele.on('click',()=>{
		a.close();
	});
}

export default growl;